import { Avatar, Icon, useToast } from "@helmr/ui";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { logout, logoutAll } from "../../api/auth";
import { isApiError } from "../../api/client";
import { LargeTitle } from "@helmr/ui";
import { useLargeTitleChrome } from "../../app/mobile/chrome";
import { mobile } from "../../app/mobile/strings";
import { AREAS } from "../../app/nav";
import { useAppContext } from "../../app/permissions";
import { useServices } from "../../app/services";
import { strings } from "../../app/strings";
import s from "./more.module.css";

const t = mobile.more;
/** Areas that already have a tab (or are not pages for people) do not repeat in the grid. */
const NOT_IN_GRID = new Set(["home", "inbox", "members", "more", "followups"]);

export function MorePage() {
  const ctx = useAppContext();
  const { client, session, queryClient } = useServices();
  const navigate = useNavigate();
  const toast = useToast();
  const [restricted, setRestricted] = useState(false);
  const onUnder = useLargeTitleChrome(t.title);
  const areas = AREAS.filter((a) => !NOT_IN_GRID.has(a.key) && a.allow(ctx.has));
  const me = ctx.me;

  async function out(everywhere: boolean) {
    try {
      await (everywhere ? logoutAll(client) : logout(client));
    } catch (err) {
      if (everywhere && isApiError(err) && err.isForbidden) { setRestricted(true); toast.show(strings.shell.signOutEverywhereRefused); return; }
      if (everywhere && !(isApiError(err) && err.status === 401)) { toast.show(strings.shell.signOutEverywhereFailed); return; }
    }
    session.signOut(null);
    queryClient.clear();
    navigate("/signin", { replace: true });
  }

  return (
    <div className={s.page}>
      <title>More · Helmr</title>
      <LargeTitle eyebrow={t.eyebrow} title={t.title} onUnderBarChange={onUnder} />
      <div className={s.prof} aria-busy={ctx.status === "loading" || undefined}>
        {me ? <><Avatar id={me.staff.id} name={me.staff.name} /><div><b>{me.staff.name}</b><small>{me.staff.roleName} · {me.business.name}</small></div></> : (
          <><span className={s.profAv}><Icon name="user" /></span><div><b>{t.profile}</b><small>{ctx.status === "loading" ? "" : t.soon}</small></div></>
        )}
      </div>
      <div className={s.grid}>
        {areas.map((a) => (
          <Link key={a.key} to={a.path}><span className={s.ti}><Icon name={a.icon} size={22} /></span>{a.label}</Link>
        ))}
      </div>
      <button type="button" className={s.so} onClick={() => void out(false)}>{t.signOut}</button>
      {restricted ? null : <button type="button" className={`${s.so} ${s.soSub}`} onClick={() => void out(true)}>{t.signOutEverywhere}</button>}
    </div>
  );
}
